import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import "./Nav.css";
import logoHorizontalIcon from 'icons/logo-horizontal.svg'; // Import the horizontal logo

/**
 * A unified navigation component that combines the styling of NavMain with
 * the conditional rendering of SimpleNav
 * @param {Object} props - Component props
 * @param {boolean} props.isAuthenticated - Whether user is authenticated
 * @param {string} props.className - Additional CSS classes
 * @returns {JSX.Element} The UnifiedNav component
 */
const UnifiedNav = ({ isAuthenticated, className = "", ...props }) => {
  // State to track if mobile menu is open
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Toggle the mobile menu
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  // Define navigation items based on authentication state
  const getNavItems = () => {
    if (isAuthenticated) {
      return [
        { path: "/chart", label: "Dashboard" },
        { path: "/board", label: "Job Board" },
        { path: "/search", label: "Search Jobs" },
        { path: "/addjob", label: "Add Job" }
      ];
    } else {
      return [
        { path: "/", label: "Home" }
      ];
    }
  };

  const navItems = getNavItems();

  return (
    <nav className={`navbar sticky-top navbar-expand-lg navbar-dark ${className}`} {...props}>
      {/* Brand/logo - always visible */}
      <Link className="navbar-brand" to="/">
        <img className="logo" src={logoHorizontalIcon} alt="Career Deer"/>
      </Link>
      
      {/* Burger menu on mobile */}
      <button 
        className="navbar-toggler" 
        type="button" 
        onClick={toggleMenu}
        aria-expanded={isMenuOpen ? "true" : "false"}
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      
      {/* Collapsible content */}
      <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarSupportedContent">
        <ul className="navbar-nav ml-auto w-100 justify-content-end">
          {/* Main navigation items */}
          {navItems.map(item => (
            <li className="nav-item" key={item.path}>
              <Link 
                to={item.path}
                className={
                  window.location.pathname === item.path ? "nav-link active" : "nav-link"
                }
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </Link>
            </li>
          ))}
          
          {/* Authentication links */}
          {!isAuthenticated && (
            <li className="nav-item dropdown">
              <Link 
                className="nav-link dropdown-toggle" 
                to="/signup" 
                id="navbarDropdown" 
                role="button" 
                data-toggle="dropdown" 
                aria-haspopup="true" 
                aria-expanded="false"
              >
                Sign Up / Login
              </Link>
              <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <Link className="dropdown-item" to="/signup">Sign Up</Link>
                <Link className="dropdown-item" to="/login">Login</Link>
              </div>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
};

// Connect to Redux to get authentication state
const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated
});

const ConnectedUnifiedNav = connect(mapStateToProps)(UnifiedNav);
export default ConnectedUnifiedNav;
export { ConnectedUnifiedNav as UnifiedNav }; 